import { useRef } from "react";
import { X } from "lucide-react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { EllipsisVertical } from "lucide-react";
import { JWT_KEY, LIST_MENU } from "@/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/utils/utils";
import { useUserStore } from "@/zustand/user";
import { ROUTE } from "@/types/router";

export function DrawerMenu() {
  const { pathname } = useLocation();
  const navigation = useNavigate();
  const { updateUser } = useUserStore();
  const closeRef = useRef<HTMLButtonElement>(null);

  const handleNavigate = (route: string) => {
    navigation(route);
    closeRef.current?.click();
  };

  const handleLogout = () => {
    localStorage.removeItem(JWT_KEY);
    updateUser({ isLogin: false });
    navigation(ROUTE.Login, { replace: true });
    closeRef.current?.click();
  };

  return (
    <Drawer direction="left">
      <DrawerTrigger asChild>
        <EllipsisVertical className="size-8 text-[#222222]" />
      </DrawerTrigger>
      <DrawerContent className="h-screen w-[234px] rounded-none border-none px-5 max-sm:w-4/5">
        <div className="">
          <DrawerHeader className="px-0">
            <DrawerClose ref={closeRef}>
              <X className="size-8" />
            </DrawerClose>
          </DrawerHeader>

          <div>
            <h2 className="mb-8 text-xl font-medium text-[#202121]">Menu</h2>

            {LIST_MENU.map((menu, index) => (
              <div key={index} className="ml-6">
                <button className="flex items-center justify-start gap-3 rounded-lg px-4 py-3 font-medium">
                  <img src={menu.icon} alt={menu.title} />
                  <span className="leading-[100%] text-text">{menu.title}</span>
                </button>

                {menu.children.map((tab, indexTab) => (
                  <button
                    key={indexTab}
                    className={cn(
                      "flex w-full items-center justify-start gap-3 rounded-lg px-4 py-3 font-normal hover:opacity-80 lg:w-[232px]",
                      {
                        "bg-button-background font-normal ": tab.screens.some(
                          (screen) => screen === pathname,
                        ),
                      },
                    )}
                    onClick={() => handleNavigate(tab.route)}
                  >
                    <div className="w-5" />
                    <span className={cn("text-left text-sm text-text")}>
                      {tab.title}
                    </span>
                  </button>
                ))}
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center gap-3" onClick={handleLogout}>
            <div className="flex size-8 items-center justify-center rounded-lg bg-[#EEF2FF]">
              <img src={"/icons/log-out.svg"} alt="icon" />
            </div>
            <p className="ml-3 text-base text-text">Logout</p>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
